import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ReportDataDispatcher } from './report-data.dispatcher';
import { ReportDataEffects } from './report-data.effects';
import { FEATURE_NAME, reducer } from './report-data.reducer';
import { ReportDataService } from './report-data.service';
import { ReportDataStore } from './report-data.store';

@NgModule({
  imports: [
    CommonModule,
    EffectsModule.forFeature([ReportDataEffects]),
    StoreModule.forFeature(FEATURE_NAME, reducer),
  ],
})
export class ReportDataModule {
  static forRoot(): ModuleWithProviders<ReportDataModule> {
    return {
      ngModule: ReportDataModule,
      providers: [ReportDataDispatcher, ReportDataService, ReportDataStore],
    };
  }
}
